"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import { SourceListener } from 'generics/dataBound';
import { WalletCheckExpiration, cachedBalance } from 'api/walletAPICall';
import WalletLimitsIcon from 'components/walletLimitsIcon';

import MoneyUtil from 'components/moneyUtil';
import ApplicationEvents from 'components/applicationEvents';

// LogStream.enable("WALLETWIDGET");
const loggerWidget  = LogStream("WALLETWIDGET");

// LogStream.enable("WALLETSENTRY");
const loggerSentry  = LogStream("WALLETSENTRY");


class WalletEventsSentry extends React.Component  {
  constructor(props)  {
    super(props);

    this.timer = null;
    this.again = false;
    this.rateTimeoutMs = 10000;

    this.ownerUserId = SettingsInjections.getCredentials().userId;

    this.onTickerEvent          = (...rest) =>  this.onTickerEvent__(...rest);
    this.onUpdateEvent          = () =>  this.schedule( true );
    this.onOrdersUpdateEvent    = () =>  this.schedule( false );
  }


  componentDidMount()  {
    this.schedule( true );
    ApplicationEvents.on("market.notify.received", this.onTickerEvent );
    ApplicationEvents.on("market.buyCoins", this.onUpdateEvent);
    ApplicationEvents.on("market.ordersUpdate", this.onOrdersUpdateEvent);
  }


  componentWillUnmount()  {
    ApplicationEvents.off("market.notify.received", this.onTickerEvent );
    ApplicationEvents.off("market.buyCoins", this.onUpdateEvent);
    ApplicationEvents.off("market.ordersUpdate", this.onOrdersUpdateEvent);
  }


  onTickerEvent__( args, kwargs, details )  {
    const {  eventType,  buyerUserId,  sellerUserId  } = ((details||{}).decodedTopic||{});

    if ( eventType == "deal" )  {
      if ( (this.ownerUserId == buyerUserId) ||
           (this.ownerUserId == sellerUserId) )  {
        this.schedule( false );
      }
    }
  }


  onTimerEnd() {
    this.timer = null;  // timer fired, ratelimiting period clear
    if ( this.again )  {
      // reschedule due to requested under timer
      this.schedule( false );
    }
  }


  schedule( forced ) {
    if ( this.timer )  {
      // got requested under ratelimiting timer
      if ( !forced )  {
        this.again = true;
        return;
      }
      cancelTimeout( this.timer );
      this.timer = null
    }

    this.again = false;  // shouldn't repeat request at the end of ratelimiting period
    this.timer = setTimeout( evt =>  this.onTimerEnd(),  this.rateTimeoutMs );

    WalletCheckExpiration( true );
  }


  render() {
    return null;
  }
}


function WalletEntry({ currency, balance })  {
  // round balances down to nearest cent
  balance = Math.floor((+balance||0)/100)*100;

  return (<div className="wallet-widget-entry">
            {MoneyUtil.formatMoney(balance)}
            &nbsp;<b>{MoneyUtil.formatCurr(currency)}</b>
          </div>);
}


function  WalletEntryList({ balances }) {
  const balanceEntries = Object.entries( balances );
  if ( balanceEntries.length == 0 )
    return <WalletEntry  currency={null} balance={0} />;

  return <span>{balanceEntries.map(
      ([ currency, balance ])  =>  <WalletEntry key={currency} currency={currency} balance={balance} />
    )}</span>;
}


export default class WalletWidgetIcon extends React.Component  {
  render() {
    return (<SourceListener balances={cachedBalance}>{
      (sources) => (
            <div  className="wallet-widget-icon"  onClick={this.props.onClick}  >
              <WalletLimitsIcon balance={sources.balances} />&nbsp;
              <WalletEntryList balances={sources.balances}/>
              <WalletEventsSentry />
            </div>
        )
    }</SourceListener>);
  }
}

